import { Button, Col, Form, Input, Row } from "antd";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import swal from "sweetalert";
import { ImageUrl } from "../../config/helpers";
import { Post } from "../../config/api/post";
import { RESET } from "../../config/constants/api";
import Modals from "../../../src/components/Modals";

const ForgotPassword3 = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const  email= location?.state?.email;
  const  code  = location?.state?.code;
  useEffect(() => {
    if (!email || !code) {
      navigate("/forgotPassword/otp");
    }
    // eslint-disable-next-line
  }, []);
  
  const [show1, setShow1] = useState(false);
  const handleShow1 = () => {
    setShow1(true);
  };
  const onFinish = (values) => {
    if (values.password !== values.confirmpassword) {
      swal("Error", "Passwords should match", "error");
      return;
    }
    setLoading(true);
    Post(RESET.resetPassword, {
      email,
      code,
      password: values.password,
      type:"ADMIN"
    })
      .then((response) => {
        if (response?.status) {
          form.resetFields();
          setLoading(false);
          handleShow1();
        }
      })
      .catch((err) => {
        console.log("Error", err);
        setLoading(false);
        swal("Error", err?.response?.data?.message, "error");
      });
  };
  return (
    <Row
      justify="center"
      style={{
        backgroundImage: `url('${ImageUrl("login.png")}')`, // Setting background color to black with 90% opacity
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
      className="h-screen max-sm:pb-8"
      gutter={[16, 0]}
    >
      <Col
        xl={8}
        lg={7}
        md={6}
        sm={0}
        xs={0}
        className="flex justify-center items-end max-md:hidden"
      >
        <img src={ImageUrl("login-2.png")} alt="" />
      </Col>
      <Col
        xl={8}
        lg={10}
        md={12}
        sm={20}
        xs={20}
        className=" items-center flex w-full"
      >
        <div
          className="flex flex-col justify-center items-center bg-white rounded-lg pb-8 px-8 max-lg:px-2 w-full pt-4"
          style={{ boxShadow: "1px 1px 1px 1px rgba(0, 0, 0, 0.05)" }}
        >
          <img src={ImageUrl("logo.png")} width={130} alt="logo" />
          <h3 className="mt-4 font-tavi text-3xl text-black max-md:text-xl">
            Forgot Password
          </h3>
          <p className="capitalize font-euclid text-sm text-[#34324B] mb-8 max-md:text-xs text-center">
            Set your new password
          </p>
          <Form
            form={form}
            name="normal_login"
            onFinish={onFinish}
            layout="vertical"
            className="w-full px-8 max-xl:px-2"
          >
            <Row justify="center">
              <Col md={24} sm={24} xs={24}>
                <Form.Item
                  name="password"
                  label="New Password"
                  rules={[
                    {
                      required: true,
                      message: "Please input password!",
                    },
                  ]}
                >
                  <Input.Password
                    placeholder="Enter New Password"
                    className="h-12 text-sm font-euclid bg-gray-100 "
                    autoComplete={false}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row justify="center">
              <Col md={24} sm={24} xs={24}>
                <Form.Item
                  name="confirmpassword"
                  label="Confirm Password"
                  rules={[
                    {
                      required: true,
                      message: "Please input password!",
                    },
                  ]}
                >
                  <Input.Password
                    placeholder="Confirm Password"
                    className="h-12 text-sm font-euclid bg-gray-100 "
                    autoComplete={false}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row justify="center">
              <Col md={12}>
                <Form.Item className="self-center text-center">
                  <Button
                    htmlType="submit"
                    className="bg-button hover:bg-white hover:border-customGold hover:border-2 font-urban font-bold text-black px-14 h-[50px] hover:text-customGold text-center text-sm"
                  >
                    {loading ? "LOADING..." : "UPDATE"}
                  </Button>
                </Form.Item>
              </Col>
            </Row>

            <Row justify="center">
              <Link
                to="/login"
                className="font-euclid text-black text-sm border-b-2 border-black font-semibold mt-8 hover:text-black"
              >
                Back to Sign In
              </Link>
            </Row>
          </Form>
        </div>
      </Col>
      <Col
        xl={8}
        lg={7}
        md={6}
        sm={0}
        xs={0}
        className="flex justify-center items-end max-md:hidden"
      >
        <img src={ImageUrl("login-1.png")} alt="" />
      </Col>
      
      <Modals
        open={show1}
        handleOk={() => setShow1(false)}
        handleCancel={() => setShow1(false)}
        text="Your password has been reset. Please login to continue."
        footer={[
          <Button
            key="submit"
            type=""
            className="web-btn"
            onClick={() => navigate("/login")}
            style={{ textAlign: "center" }}
          >
            Continue
          </Button>,
        ]}
      />
    </Row>
  );
};

export default ForgotPassword3;
